import React, { useEffect, useState } from "react";
import Chatbox from "../box-chat";
import useAppAccessor from "../../../../hooks/useappAccessor";

const AttendessChat = () => {
  const { getLiveMainData } = useAppAccessor();
  const { createStreamData, attendeeList } = getLiveMainData();

  const truncateFullName = (firstName:any, lastName:any, index:any) => {
    if (firstName && lastName && index === 0) {
      const datafirstName = firstName.split(" ");
      const datalastName = lastName.split(" ");
      return datalastName[datalastName.length - 1] + " " +  datafirstName[0];
    } 
    if(firstName && lastName && index !== 0) {
      const datafirstName = firstName.split(" ");
      const datalastName = lastName.split(" ");
      return datafirstName[0]  + " " + datalastName[datalastName.length - 1];
    }
  };


  useEffect(() => {
   // console.log("stststts===>", createStreamData);
  }, [createStreamData]);

  return (
    <div>
      {/* <p className="text-white text-center">this is attendees</p> */}

      {attendeeList.map((data: any, index: any) => {
        return (
          <div>
            <div className="flex flex-row pl-2 pr-2 mt-3" key={index}>
              <div className="flex rounded-full h-[45px] w-[45px] min-w-[45px] min-h-[45px] items-center justify-center mr-3">
                {data && data.avatar && data.avatar.length > 0 ? (
                  <img style={{ borderRadius: "50%" }} src={data.avatar} />
                ) : (
                  <span className="text-white">
                    {data?.firstName && data?.lastName ? (
                    `${Array.from(data.firstName)[0] || ''}${Array.from(data.lastName)[0] || ''}`
                  ) : (
                    'N/A' // Fallback in case firstName or lastName is not available
                  )}
                  </span>
                )}
              </div>

              <div className="flex flex-col p-4 rounded">
                <span className="text-white text-xs font-semibold">
                  {truncateFullName(data?.firstName, data?.lastName, index)}
                </span>
              </div>
            </div>
            <div
              className="ml-2 mr-2"
              style={{
                marginTop: "10px",
                height: "0.5px",
                backgroundColor: "#eeeeee",
                opacity: 0.5,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AttendessChat;
